import { TEXT_COLUMNS } from '../components/materials/materialPresentationConstants';

/**
 * Alineación de una celda de reporte de materiales: texto a la izquierda, cantidades e importes
 * a la derecha.
 * @param {string} key Clave de la columna.
 * @param {Object} [extraSx] Estilos adicionales de la celda.
 * @returns {Object} `sx` de la celda.
 */
export const getMaterialCellSx = (key, extraSx = {}) => ({
  textAlign: TEXT_COLUMNS.includes(key) ? 'left' : 'right',
  ...extraSx,
});
